<template>
    <div class="full-height flex">
        <nested-file-sidebar v-on:change-category="changeCategory"/>
        <div id="content-wrapper">
            <header id="header" class="no-bg">
                <div class="container">
                    <div>
                        <ul class="breadcrumbs">
                            <li>
                                <router-link :to="{ name: 'view-group', params: { group: group.slug }}">
                                    {{ group.name }}
                                </router-link>
                            </li>
                            <li v-for="crumb in breadcrumbs" :key="crumb.id">
                                <router-link :to="{ name: 'view-category', params: { group: group.slug, category: crumb.slug }}">
                                    {{ crumb.name }}
                                </router-link>
                            </li>
                        </ul>
                        <h1 v-if="breadcrumbs && breadcrumbs.length === 0">{{ group.name }}</h1>
                        <h1 v-if="breadcrumbs && breadcrumbs.length !== 0">{{ breadcrumbs[breadcrumbs.length - 1].name }}</h1>
                    </div>

                    <div class="actions">
                        <router-link class="btn btn-small" :to="{ name: 'edit-group'}" v-if="!category && group.can.edit">Group settings</router-link>
                        <a v-on:click.stop.prevent="openModal('edit-category')" class="btn btn-small" v-if="category && group.can.edit">Edit folder</a>

                        <category-modal v-if="category && group.can.edit" :category="category" v-on:edit-category="updateCategories"></category-modal>

                        <post-file-upload 
                            name="featured-image-upload" 
                            v-if="group.can.createPosts" 
                            :group="group" 
                            :filters="filters" 
                            label="Upload files"
                            v-on:new-file="newFile"
                            btnClass="btn-primary"
                        ></post-file-upload>
                    </div>
                </div>
                <nav class="container">
                    <div v-if="selectedCount > 0" class="bulk-actions">
                        <span>{{ selectedCount }} {{ fileOrFiles }} selected</span>
                        <button class="btn btn-small" v-on:click.stop.prevent="openModal('move-files')">
                            <i class="icon ion-md-redo"></i> Move
                        </button>
                        <button class="btn btn-small btn-danger" v-on:click.stop.prevent="openModal('delete-files')">
                            <i class="icon ion-md-trash"></i> Delete
                        </button>

                    </div>

                    <div class="modal micromodal-slide" id="move-files" aria-hidden="true">
                        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                            <div class="modal__container" role="dialog" aria-modal="true">
                                <div class="modal__content" id="modal-move-files-content">
                                    <h3>Move {{ selectedCount }} {{ fileOrFiles }}</h3>
                                    <p>Select a folder from the list below</p>
                                    <DraggableTree :data="group.categories" :draggable="false" :space="0" v-if="group.categories">
                                        <div slot-scope="{data, store}">
                                            <template v-if="!data.isDragPlaceHolder">
                                                <span v-on:click.stop.prevent="moveFolder = data.slug" :class="(moveFolder == data.slug)?'active':''">
                                                    <i class="icon ion-md-folder"></i> {{ data.name }}
                                                </span>
                                            </template>
                                        </div>
                                    </DraggableTree>
                                </div>
                                <footer class="modal__footer">
                                    <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                                    <button class="btn btn-primary" v-on:click.stop.prevent="moveFiles">Move</button>
                                </footer>
                            </div>
                        </div>
                    </div>

                    <div class="modal micromodal-slide" id="delete-files" aria-hidden="true">
                        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                            <div class="modal__container" role="dialog" aria-modal="true">
                                <div class="modal__content" id="modal-delete-files-content">
                                    <h3>Delete {{ selectedCount }} {{ fileOrFiles }}</h3>
                                    <p>Are you sure you wish to delete the {{ selectedCount }} selected {{ fileOrFiles }}</p>
                                </div>
                                <footer class="modal__footer">
                                    <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                                    <button class="btn btn-danger" v-on:click.stop.prevent="deleteFiles">Delete</button>
                                </footer>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
            <div class="container-fluid">
                <div class="grid grid-bleed">
                    <div class="col-1"></div>
                    <div class="col-10">
                        
                        <div class="panel">
                            <ListFiles 
                                ref="filesTable" 
                                :filters="filters"
                                :apiURL="apiURL" 
                                v-on:breadcrumbs-update="updateBreadcrumbs"
                                v-on:selected-post="selectedPost"
                                v-on:deselected-post="deselectedPost"
                            >
                            </ListFiles>

                            <category-modal :category="new_category" v-on:new-category="insertCategory"></category-modal>
                        </div>
                    </div>
                    <div class="col-1"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import MicroModal from 'micromodal';
    import ListFiles from '../../../list/ListFiles';
    import {DraggableTree} from 'vue-draggable-nested-tree';

    export default {
        components: {
            ListFiles,
            DraggableTree
        },
        watch: {
            category: {
                deep: true,
                handler() {
                    this.changeCategory( this.category );
                }
            }
        },
        computed: {
            selectedCount(){
                return Object.keys(this.selectedPosts).length
            },
            fileOrFiles(){
                if( this.selectedCount === 1 ){
                    return 'file';
                }

                return 'files';
            },
            ...mapState({
                group: state => state.group.group,
            })
        },
        props: ['category'],
        data() {
            return {
                breadcrumbs: null,
                apiURL: '/api/groups/' + this.$route.params.group + "/posts",
                filters: {
                    category: this.category,
                },
                new_category: null,
                selectedPosts: {},
                moveFolder: null
            }  
        },
        created() {
            // this.group = JSON.parse(JSON.stringify(this.group));
            if(this.$route.params.category){
                this.changeCategory(this.$route.params.category);
            }
        },
        methods: {
            openModal(modal) {
                MicroModal.show(modal);
            },
            newFile() {
                this.$refs.filesTable.$refs.vuetable.refresh();
            },
            changeCategory(category) {
                this.filters.category = category;
            },
            updateBreadcrumbs(breadcrumbs) {
                this.breadcrumbs = breadcrumbs;
            },
            updateCategories(category) {
                this.group.categories.forEach((cat, index) => {
                    if(cat.id === category.id) {
                        this.$set(this.group.categories, index, category);
                    }
                });
            },
            insertCategory(category) {
                category.children = [];
                this.$set(this.group.categories, this.group.categories.length, category);
                //this.group.categories.push(category);
            },
            selectedPost(post) {
                this.$set(this.selectedPosts, post.id, post);
            },
            deselectedPost(post) {
                this.$delete(this.selectedPosts, post.id);
            },
            moveFiles(){
                if(this.moveFolder){
                    var url = '/api/groups/' + this.$route.params.group + '/categories/' + this.moveFolder + "/bulk-move";

                    axios.patch(url, {posts: Object.keys(this.selectedPosts)}).then((response) => {
                        MicroModal.close("move-files");
                        this.selectedPosts = [];
                        this.moveFolder = null;
                        this.$refs.filesTable.$refs.vuetable.refresh();
                    }, (response) => {
                        this.error = response;
                    });
                }
            },
            deleteFiles(){
                if(this.selectedPosts){
                    var url = '/api/groups/' + this.$route.params.group + "/bulk-delete";

                    axios.patch(url, { posts: Object.keys(this.selectedPosts) } ).then((response) => {
                        this.selectedPosts = [];
                        this.$refs.filesTable.$refs.vuetable.refresh();
                        MicroModal.close("delete-files");
                    }, (response) => {
                        this.error = response;
                    });
                }
            }
        }
    }
</script>